import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dahhf6joh653ivfvnvl0';

const highlights = [
  { icon: 'ri-calendar-check-line', title: '每天一封', text: '固定在晚间推送，内容不啰嗦。' },
  { icon: 'ri-list-check-2', title: '按方向推送', text: '只发你关注分类里讨论度最高的话题。' },
  { icon: 'ri-logout-box-r-line', title: '随时退订', text: '邮件底部一键退订，不打扰。' },
];

export default function SubscribeSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('phone_alt') ?? '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功，我们会按你关注的方向推送今日瓜单。');
      form.reset();
      return;
    }

    setSubmitting(true);
    setStatus('idle');
    setMessage('');

    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key === 'phone_alt') return;
        const text = String(value).trim();
        if (text) payload.append(key, text);
      });

      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }

      const codeOk = parsed?.code === 'OK';
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const looksSpam = /spam|form data is spam/i.test(serverMsg);

      if (response.ok && codeOk && !looksSpam) {
        setStatus('success');
        setMessage('订阅成功，我们会按你关注的方向推送今日瓜单。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(
          serverMsg && !looksSpam
            ? serverMsg
            : '提交没有成功，请检查邮箱格式后再试一次。',
        );
      }
    } catch {
      setStatus('error');
      setMessage('网络好像有点问题，请稍后重试。');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="subscribe" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="bg-primary-500 rounded-lg overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="lg:col-span-5 p-8 md:p-12">
              <p className="text-xs tracking-[0.3em] text-primary-100 font-medium mb-3">
                NEWSLETTER
              </p>
              <h2 className="font-heading font-black text-2xl md:text-4xl text-background-50 leading-tight">
                订阅今日瓜单
              </h2>
              <p className="mt-4 text-sm md:text-base text-primary-50/95 leading-relaxed">
                留下邮箱，我们会把当天讨论度最高的话题整理成一封简短推送，帮你不漏掉真正值得看的热点。
              </p>

              <ul className="mt-8 space-y-4">
                {highlights.map((item) => (
                  <li key={item.title} className="flex items-start gap-3">
                    <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-primary-600 text-background-50">
                      <i className={item.icon} aria-hidden="true"></i>
                    </span>
                    <span>
                      <span className="block font-heading font-bold text-sm text-background-50">
                        {item.title}
                      </span>
                      <span className="block text-xs text-primary-50/90 mt-0.5">{item.text}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-7 bg-background-50 p-8 md:p-12">
              <form
                id="hcg-subscribe-form"
                data-readdy-form
                onSubmit={handleSubmit}
                className="w-full flex flex-col gap-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label
                      htmlFor="sub-email"
                      className="block text-sm font-medium text-foreground-800 mb-2"
                    >
                      邮箱 <span className="text-primary-600">*</span>
                    </label>
                    <input
                      id="sub-email"
                      type="email"
                      name="email"
                      required
                      placeholder="you@example.com"
                      className="w-full h-11 px-4 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="sub-nickname"
                      className="block text-sm font-medium text-foreground-800 mb-2"
                    >
                      瓜友昵称
                    </label>
                    <input
                      id="sub-nickname"
                      type="text"
                      name="nickname"
                      maxLength={20}
                      placeholder="想被怎么称呼"
                      className="w-full h-11 px-4 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="sub-interest"
                    className="block text-sm font-medium text-foreground-800 mb-2"
                  >
                    最想追的方向
                  </label>
                  <select
                    id="sub-interest"
                    name="interest"
                    defaultValue="娱乐八卦"
                    className="w-full h-11 px-4 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 cursor-pointer"
                  >
                    <option value="娱乐八卦">娱乐八卦</option>
                    <option value="影视综艺">影视综艺</option>
                    <option value="网红动态">网红动态</option>
                    <option value="音乐现场">音乐现场</option>
                    <option value="时尚潮流">时尚潮流</option>
                    <option value="体育花边">体育花边</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="sub-note"
                    className="block text-sm font-medium text-foreground-800 mb-2"
                  >
                    想让我们多聊点什么（选填）
                  </label>
                  <textarea
                    id="sub-note"
                    name="note"
                    rows={3}
                    maxLength={500}
                    placeholder="最多 500 字，说说你最近在关注什么"
                    className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 resize-none"
                  ></textarea>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-verify-extra"
                />

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full sm:w-auto sm:self-start px-8 h-12 rounded-md bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  {submitting ? '提交中…' : '免费订阅瓜单'}
                </button>

                {status !== 'idle' && (
                  <p
                    role="status"
                    className={`text-sm rounded-md px-4 py-3 ${
                      status === 'success'
                        ? 'bg-secondary-100 text-secondary-900'
                        : 'bg-primary-100 text-primary-800'
                    }`}
                  >
                    {message}
                  </p>
                )}

                <p className="text-xs text-foreground-500">
                  我们只用于发送瓜单推送，不会将邮箱用于其他用途，随时可一键退订。
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}